import WixSDK from 'shared/utils/wix-sdk';
import NewRelic from './new-relic';
import { attempt } from 'shared/utils/attempt';

let newRelic;
export function initNewRelic(customAttributes) {
  newRelic = new NewRelic(global.newrelic, location.host);
  newRelic.setCustomAttribute('viewMode', attempt(() => WixSDK.Utils.getViewMode()));

  _.forEach(customAttributes, (value, name) => newRelic.setCustomAttribute(name, value));

  global.addEventListener('error', function (event) {
    newRelic.logError(event.error);
  });

  const previousOnunhandledrejection = global.onunhandledrejection;

  global.onunhandledrejection = function (event) {
    newRelic.logError(event.reason);
    console.error('Unhandled promise rejection', event.reason); // eslint-disable-line no-console
    if (previousOnunhandledrejection) {
      previousOnunhandledrejection(event);
    }
  };
}

export function getNewRelic() {
  if (!newRelic) {
    throw new Error('new relic was not inited');
  }
  return newRelic;
}



// WEBPACK FOOTER //
// ./src/shared/analytics/new-relic/index.js